import { createFileRoute } from "@tanstack/react-router";
import { ApexStylePage } from "@/features/game/apex-style/apex-style-page";
import {
  createStructuredDataScript,
  generateWebApplicationStructuredData,
  seo,
  SEO_SITE_URL,
} from "@/lib/utils/seo";

export const Route = createFileRoute("/_index/game/apex-style")({
  component: RouteComponent,
  head: () => ({
    meta: [
      ...seo({
        title: "Apex 打法风格测试 - 发现你的游戏风格 | CN Apex Club",
        description:
          "通过专业的 Apex Legends 打法风格测试，分析你的游戏策略、心理素质和团队配合能力。AI 智能分析提供个性化建议，帮助你找到最适合的游戏风格。",
        keywords: "Apex Legends,打法风格,游戏测试,AI分析,游戏策略,团队配合,心理素质,CN Apex Club",
        url: `${SEO_SITE_URL}/game/apex-style`,
        type: "website",
      }),
    ],
    scripts: [
      createStructuredDataScript(
        generateWebApplicationStructuredData({
          name: "Apex 打法风格测试",
          description: "通过问答分析你在 Apex Legends 中的游戏风格",
          url: `${SEO_SITE_URL}/game/apex-style`,
        }),
      ),
    ],
  }),
});

function RouteComponent() {
  return <ApexStylePage />;
}
